<template lang="html">
	<form :class="panelClass" @submit.prevent="next" @keydown.enter="next">
		<common-progress-steps v-if="completed" :completed="completed" :total="total" />
		<div class="omapi-card" :class="cardClass">
			<div class="omapi-card-content" :class="contentClass">
				<div
					v-if="completed"
					ref="toFocus"
					class="omapi-onboarding__steps"
					:class="`omapi-onboarding__step-${step}`"
					tabindex="0"
				>
					Step {{ completed }} of {{ total }}
				</div>
				<slot></slot>
			</div>
			<!--omapi-card-content-->
			<slot name="footer">
				<div v-if="navPrev || navNext" class="omapi-card-footer">
					<wizard-prev-link v-if="navPrev" :disabled="'disabled' === navPrev" />
					<wizard-next-link v-if="navNext" :text="navNextText" :disabled="'disabled' === navNext" />
				</div>
			</slot>
		</div>
		<!--card-->
		<slot v-if="showExit" name="after-card">
			<wizard-exit />
		</slot>
	</form>
</template>

<script lang="js">
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
	props : {
		completed : {
			type : [ Number, Boolean ],
			default () {
				return 1
			},
		},
		total : {
			type : Number,
			default () {
				return 1
			},
		},
		navPrev : {
			type     : [ Boolean, String ],
			default  : true,
		},
		navNext : {
			type     : [ Boolean, String ],
			default  : true,
		},
		navNextText  : {
			type     : String,
			default  : 'Next Step',
		},
		showExit : {
			type     : Boolean,
			default  : true,
		},
		panelClass   : {
			type     : String,
			default  : '',
		},
		cardClass    : {
			type     : String,
			default  : '',
		},
		contentClass : {
			type     : String,
			default  : '',
		},
	},
	computed : {
		...mapState('wizard', [ 'step' ]),
		...mapState([ 'apiKey' ]),
		...mapGetters([ 'userId', 'onboardingVia' ]),
		wizardLoading () {
			return this.apiKey && this.$store.getters.isLoading('me')
		},
	},
	watch : {
		wizardLoading (isLoading, wasLoading) {
			if (wasLoading) {
				this.maybeSkipToFinish()
			}
		},
		step () {
			this.maybeGoBack()
		},
	},
	mounted () {
		this.$nextTick(() => {
			if (this.$refs.toFocus) {
				this.$refs.toFocus.focus()
			}
		})

		this.maybeSkipToFinish()
		this.maybeGoBack()
	},
	methods : {
		...mapActions('wizard', [ 'maybeGoBack' ]),
		next () {
			this.$bus.$emit('onboardingNextPage')
		},
		maybeSkipToFinish () {
			if (
				this.userId &&
				this.apiKey &&
				'wordpress' === this.onboardingVia &&
				5 > this.step
			) {
				this.$store.commit('wizard/setStep', 5)
			}
		},
	},
};
</script>
